module.exports = __webpack_public_path__ + "images/places/training_649-5ad7843a5083b9f7001078741ef7910a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_649.jpg
 ** module id = 317
 ** module chunks = 0
 **/